import { MuiTypography } from '@/features/shared/material-ui';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

const usePortalTitlePageStyles = makeStyles(({ palette }) => ({
  title: {
    color: palette.primary.contrastText,
  },
}));

const PortalTitlePage = ({ children, className, ...restProps }: PropsWithChildren<any>) => {
  const classes = usePortalTitlePageStyles();
  return (
    <MuiTypography
      variant="h4"
      component="h4"
      className={clsx(classes.title, className)}
      {...restProps}
    >
      {children}
    </MuiTypography>
  );
};

export default PortalTitlePage;
